<div class="container-fluid d-flex flex-column h-100 px-0">
  <div class="row mx-0 px-0 d-flex justify-content-between mt-2">
    <div class="col-12 px-0 d-flex mt- mb-2 justify-content-between">
      <div class="col-6 d-flex align-items-center mt-0">
        <ul
          ngbNav
          #nav="ngbNav"
          [(activeId)]="activeTabId"
          (navChange)="onTabChange($event)"
          class="nav-tabs administration_nav_tabs gap-1"
        >
          <li [ngbNavItem]="1">
            <a ngbNavLink class="d-flex">
              <span class="d-flex justify-content-center f-14 font-semibold"
                >Installment Entry</span>
            </a>
            <ng-template ngbNavContent>
              <app-installment-entry (sendDataToChild)="onReceiviInstallMent($event)" (dataAndRowEmitter)="handleDataAndRow($event)" [layawaysData]="layawaysData" [invoiceDetailId]="invoiceDetailId"></app-installment-entry>
            </ng-template>
          </li>
          <li [ngbNavItem]="2">
            <a ngbNavLink class="d-flex">
              <span class="d-flex justify-content-center f-14 font-semibold"
                >Installment Report</span>
            </a>
            <ng-template ngbNavContent>
              <app-installment-report></app-installment-report>
            </ng-template>
          </li>
          <li [ngbNavItem]="3">
            <a ngbNavLink class="d-flex">
              <span class="d-flex justify-content-center f-14 font-semibold"
                >Layaways Report</span>
            </a>
            <ng-template ngbNavContent>
             <app-layaways-report  (changeTabEvent)="getLayawaysDetails($event)" ></app-layaways-report>
            </ng-template>
          </li>
        </ul>
      </div>
      <div class="col d-flex align-items-center justify-content-end gap-1">
        <app-button
        *ngIf="activeTabId==1 && !isAddDetails && this.installmentEntryComponent?.selectedLedgerData?.againstInvoiceNo && this.installmentEntryComponent?.formModel?.footerCalculation?.isAllPaymentsDone && !this.installmentEntryComponent?.selectedLedgerData?.isPickupDone"
          class="pe-2"
          [buttonLabel]="'Pickup'"
          [buttonClass]="'pink_button text-nowrap'"
          [buttonId]="'pickup'"
          [buttonType]="'submit'"
          (buttonOutputEvent)="openConfirmationPopup()"
          >
        </app-button>
        <app-button
        *ngIf="activeTabId==1 && !isAddDetails && !this.installmentEntryComponent?.selectedLedgerData?.againstInvoiceNo"
          class="pe-2"
          [buttonLabel]="'Fund Withdraw'"
          [buttonClass]="'pink_button text-nowrap'"
          [buttonId]="'fund_withdraw'"
          [buttonType]="'submit'"
          [disabled]="isFundWithdrawDisabled()"
          (buttonOutputEvent)="openFundWithdrawOrTransferPopup('Fund Withdraw')"
          >
        </app-button>
          <app-button
          *ngIf="activeTabId==1 && !isAddDetails && !this.installmentEntryComponent?.selectedLedgerData?.againstInvoiceNo" 
          class=""
          [buttonLabel]="'Fund Transfer'"
          [buttonId]="'fundTransfer'"
          [buttonClass]="'blue_button'"
          [buttonType]="'submit'"
          [disabled]="isfundTransferDisabled()"
          (buttonOutputEvent)="openFundWithdrawOrTransferPopup('Fund Transfer')"
        >
        </app-button>
        <app-button
        *ngIf="isAddDetails==true && activeTabId !== 3"
          [buttonLabel]="receivedData"
          [buttonId]="'addcreateSchemeButton'"
          [buttonClass]="'blue_button'"
          [buttonType]="'submit'"
          (buttonOutputEvent)="saveSettings()"
          [ngbTooltip]="sendDataService?.noPermissionTooltip"
          [disableTooltip]="((createSchemeComponent?.formModel?.id) ? sendDataService?.permissionVM?.investmentFundCanUpdate : sendDataService?.permissionVM?.investmentFundCanAdd)"
          [disabled]="!((installmentEntryComponent?.InstallmentEntryForm?.valid && installmentEntryComponent?.installmentEntryModel.accountLedgerId) && ((createSchemeComponent?.formModel?.id ) ? sendDataService?.permissionVM?.investmentFundCanUpdate : sendDataService?.permissionVM?.investmentFundCanAdd))"
        >
        </app-button>
     <div *ngIf="activeTabId !== 1" class="d-flex gap-1 align-items-center">
      <app-button  (click)="openAdvanceFilterPopUp()" showFilterIcon="true"
      [buttonClass]="'white_button common-filter-size gap-0'" [isFilterCount]="activeTabId === 2 ? installmentReportComponent?.filterCountValue : activeTabId === 3 ? layawaysReportComponent?.filterCountValue : null"
      [buttonType]="'button'" position="true" showIconCount="true">
    </app-button>
    <app-button *ngIf="activeTabId !== 1" showRefreshIcon="true"
      [buttonClass]="'white_button common-refresh-size gap-0'" [buttonType]="'button'" (buttonOutputEvent)="resetFilter()">
    </app-button>
     </div>
      <app-export-dropdown  *ngIf="activeTabId !=1" [requestModel]="exportBindParameterBasedOnTab(exportDropdownBindDynamicParameter?.RequestModel)" 
      [gridApi]="exportBindParameterBasedOnTab(exportDropdownBindDynamicParameter?.GridApi)"
      [gridName]="exportBindParameterBasedOnTab(exportDropdownBindDynamicParameter?.GridName)"
      (callApiForExport)="callApiForExport()" ></app-export-dropdown>
      </div>
    </div>
  </div>
  <hr class="mt-0 mb-1" />
  <div [ngbNavOutlet]="nav" class="mt-1 h-100" [ngClass]="{'d-flex flex-column': activeTabId == 2}"></div>
</div>
